import { ErrorButton, ErrorPageWrapper, ErrorText, ErrorTitle } from './styled'

export const ErrorPage = (): JSX.Element => {
  return (
    <ErrorPageWrapper>
      <ErrorTitle>We&apos;re Sorry</ErrorTitle>
      <ErrorText>An error occurred. Please try again.</ErrorText>
      <ErrorButton onClick={() => window.location.reload()}>Reload Page</ErrorButton>
    </ErrorPageWrapper>
  )
}
